import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const COCO_RATE_QUERY_KEY = ["coco-rate"] as const;

/**
 * Taux de conversion Coco -> XPF lu dans `app_settings.coco_rate`.
 * Convention historique du projet : xpf = coco / rate.
 * Retourne 0 tant que la valeur n'est pas chargée (aucune valeur en dur).
 * Partagé entre toutes les cartes d'une page (une seule requête, 60 s).
 */
export const useCocoRate = () => {
  const { data } = useQuery({
    queryKey: COCO_RATE_QUERY_KEY,
    staleTime: 60_000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("app_settings")
        .select("value")
        .eq("key", "coco_rate")
        .maybeSingle();
      if (error) console.error("Lecture du taux Coco impossible:", error);
      if (!data?.value) return 0;
      const raw =
        typeof data.value === "object" && data.value !== null && "rate" in data.value
          ? (data.value as { rate: unknown }).rate
          : data.value;
      const parsed = Number(raw);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
    },
  });
  return data ?? 0;
};
